// extracted by mini-css-extract-plugin
module.exports = {"dueAmountContainer":"QuickLoanRepayment_dueAmountContainer__3rIVT","title":"QuickLoanRepayment_title__P5H_j","credit_balance":"QuickLoanRepayment_credit_balance__3eBVe"};